exports.components = {
  "component---src-pages-cv-js": () => import("./../../../src/pages/cv.js" /* webpackChunkName: "component---src-pages-cv-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-portfolio-lomb-js": () => import("./../../../src/pages/portfolio/lomb.js" /* webpackChunkName: "component---src-pages-portfolio-lomb-js" */)
}

